const loadedScripts = new Map<string, Promise<void>>();

export function loadScript(src: string): Promise<void> {
  if (loadedScripts.has(src)) {
    return loadedScripts.get(src)!;
  }

  if (typeof document === "undefined") {
    return Promise.resolve();
  }

  const existing = document.querySelector<HTMLScriptElement>(`script[data-dynamic="${src}"]`);
  if (existing) {
    if (existing.getAttribute("data-loaded") === "true") {
      const promise = Promise.resolve();
      loadedScripts.set(src, promise);
      return promise;
    }
    const promise = new Promise<void>((resolve, reject) => {
      existing.addEventListener("load", () => {
        existing.setAttribute("data-loaded", "true");
        resolve();
      });
      existing.addEventListener("error", () => reject(new Error(`Failed to load script: ${src}`)));
    });
    loadedScripts.set(src, promise);
    return promise;
  }

  const promise = new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.defer = true;
    script.dataset.dynamic = src;
    script.addEventListener("load", () => {
      script.setAttribute("data-loaded", "true");
      resolve();
    });
    script.addEventListener("error", () => reject(new Error(`Failed to load script: ${src}`)));
    document.body.appendChild(script);
  });

  loadedScripts.set(src, promise);
  return promise;
}
